



















import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import Sidebar from '@/components/LayoutSidebar.vue';
import Header from '@/components/LayoutHeader.vue';
import Loader from '@/components/SimpleLoader.vue';

export default Vue.extend({
  name: 'App',
  components: {
    Sidebar,
    Header,
    Loader,
  },
  computed: {
    ...mapGetters('auth', ['isInitialAuthFinished']),
  },
  created(): void {
    // try to automatically log in user
    this.AUTHENTICATE_USER()
      .catch(() => {
        this.LOGOUT_USER();
      })
      .finally(() => {
        this.INITIAL_AUTH_FINISHED();
      });
  },
  methods: {
    ...mapActions('auth', ['AUTHENTICATE_USER', 'LOGOUT_USER', 'INITIAL_AUTH_FINISHED']),
  },
});
